@if (isActive) {
  <topo-modal
    [isActive]="isActive"
    [backgroundCanClose]="true"
    [isCard]="true"
    (close)="cancelClick()"
    [width]="1024"
    (contentScrolled)="contentScrolled()"
    [removeHeaderBottomPadding]="true"
    [noHeaderBorder]="true"
    >
    >
    <div class="modal-header">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">{{ selectedChannel?.channelName | translate }} - {{ selectedEverbridgeTemplatePreview?.title }}</h5>
        <div class="dialog-close" (click)="close()"><i class="icon icon-close-X"></i></div>
      </div>
      <div style="width: 100%">
        <topo-tabs [selectedTabIndex]="selectedTabIndex" [tabs]="tabs" (selectedTabIndexChanged)="tabChanged($event)"></topo-tabs>
      </div>
    </div>
    <div class="modal-body">
      <div [hidden]="selectedTabIndex !== 0">
        <div>
          <div class="text is-xlarge mb-1">{{ 'MAP.COMMUNICATION-MASSCOMMS-UPDATE-MESSAGE' | translate }}</div>
          <br/>
          <div class="field">
            <div class="label">{{ 'MAP.COMMUNICATION-EVERBRIDGE-TITLE' | translate }}</div>
            <div class="mb-2"><input type="text" class="input is-medium" name="title" [(ngModel)]="selectedEverbridgeTemplatePreview.title" /></div>
          </div>
          <div class="field">
            <div class="label">{{ 'MAP.COMMUNICATION-EVERBRIDGE-MESSAGE' | translate }}</div>
            <div>
              <textarea
                name="textMessage"
                class="textarea everbridge-message-field"
                [(ngModel)]="selectedEverbridgeTemplatePreview.textMessage"
              ></textarea>
            </div>
          </div>
          <div class="field">
            <div class="label">{{ 'MAP.COMMUNICATION-EVERBRIDGE-SMS-MESSAGE' | translate }}</div>
            <div>
              <textarea
                name="textSmsMessage"
                class="textarea everbridge-sms-message-field"
                [(ngModel)]="selectedEverbridgeTemplatePreview.textSmsMessage"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
      <div [hidden]="selectedTabIndex !== 1" style="min-height: calc(100vh - 200px)">
        <div class="text is-xlarge mb-2">{{ 'MAP.RECIPIENTS' | translate }}</div>
        <div class="label">{{ 'MAP.TO' | translate }}</div>
        <div class="mb-3">
          <topo-contact-select
            placeholder="{{ 'MAP.ENTER-PEOPLE-GROUPS' | translate }}"
            [(ngModel)]="toSelectedRecipients"
            [channelType]="channelType"
            [channelUId]="selectedChannel.channelUId"
            [datasets]="contactDatasets"
          ></topo-contact-select>
        </div>
        <div class="separator"></div>
        <div class="mt-4" fxLayout="row" fxLayoutAlign="space-between center">
          <h5 class="mx-4 my-4">{{ assetContactsForDisplay?.length }} {{ 'MAP.CONTACTS-SELECTED-ASSETS' | translate }} {{ 'MAP.WITH-EVERBRIDGE-ID' | translate }}</h5>
          <div class="field">
            @if (!isDrawn) {
              <div class="select mt-3">
                <select [(ngModel)]="distanceValue" name="distance" (change)="onChangeAssetDistance()">
                  @for (option of distanceOptions; track option.value) {
                    <option [ngValue]="option.value">{{ 'MAP.ASSETS-WITHIN' | translate: { distance: option.value, unit: longDistanceUnit } }}</option>
                  }
                </select>
              </div>
            }
            @if (isDrawn) {
              <div class="mt-3">
                {{ 'MAP.WITHIN-LASSO' | translate }}
              </div>
            }
          </div>
        </div>
        <div style="position: relative !important; top: 200px">
          <ngx-spinner
            bdColor="rgba(0,0,0,.1)"
            size="medium" color="#4D33CC"
            type="ball-clip-rotate"
            [fullScreen]="false"
            [zIndex]="998"
            >
            <h5 style="position: absolute !important; top: 36px; right: -184px; width: 300px;" class="mx-4 my-4">{{ 'MAP.GATHERING-CONTACTS' | translate }}</h5>
          </ngx-spinner>
        </div>
        <div [hidden]="skeletonLoad || assetContactsForDisplay?.length !== 0">
          <div fxLayout="row" fxLayoutAlign="center center" style="margin-top: 200px;">
            <img src="https://files.topo.ai/images/email/illustration_no-results.svg" />
          </div>
          <div fxLayout="row" fxLayoutAlign="center center">
            <h5 fxLayout="row" fxLayoutAlign="center center" class="mx-4 my-4" style="width: 300px;">{{ 'MAP.NO-CONTACTS' | translate }}</h5>
          </div>
        </div>
        @if (!skeletonLoad && assetContactsForDisplay?.length > 0) {
          <topo-table
            [showHeader]="false"
            [showNewItem]="false"
            [showPager]="false"
            [showSearch]="false"
            [showCount]="false"
            [useSmallHeaderLabel]="true"
            [enableDragDrop]="false"
            headerLabel="{{ 'MANAGEMENT.DATASETS.PICKLIST-VALUES' | translate }}"
            itemName="{{ 'MANAGEMENT.DATASETS.DATAFEED' | translate }}"
            [items]="assetContactsForDisplay"
            (sort)="onSort($event)"
            (checkboxSelected)="selectAll($event)"
            >
            <topo-columns>
              <topo-column hasCheckbox="true" [isChecked]="isAllChecked" [cellStyle]="{ width: '20px'}">
                <ng-template let-item="item">
                  <label class="checkbox" style="padding-top: 10px; padding-bottom: 10px;">
                    <input
                      id="{{ item.contactId }}"
                      type="checkbox"
                      name="{{ item.contactId }}"
                      (click)="onIsActiveClick($event, item)"
                      class="checkbox"
                      />
                    <span></span>
                  </label>
                </ng-template>
              </topo-column>
              <topo-column label="{{ 'MAP.CONTACT' | translate }}" [cellStyle]="{ width: '170px' }" sortField="Name">
                <ng-template let-item="item">
                  {{ item.name }}
                </ng-template>
              </topo-column>
              <topo-column label="{{ 'DATATYPES.DISTANCE' | translate }}" [cellStyle]="{ width: '50px' }" sortField="Distance">
                <ng-template let-item="item">
                  {{ item.distanceText }}
                </ng-template>
              </topo-column>
            </topo-columns>
          </topo-table>
        }
      </div>
    </div>
    <div class="modal-footer">
      <div fxLayout="row" fxLayoutAlign="end" class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button class="button is-secondary" (click)="cancelClick()">{{ 'MAP.CANCEL' | translate }}</button>
        </div>
        <div>
          <button class="button is-primary" (click)="sendClick()">{{ 'MAP.SEND' | translate }}</button>
        </div>
      </div>
    </div>
  </topo-modal>
}
